import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreRoutingModule } from './core-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';

import { HomepageComponent } from '../components/homepage/homepage.component';
import { LoginComponent } from '../components/auth/login/login.component';
import { RegisterComponent } from '../components/auth/register/register.component';


import {MatCardModule, MatProgressSpinnerModule} from '@angular/material';


import { AngularFireModule } from '@angular/fire';
import { environment } from 'src/environments/environment';


@NgModule({
  declarations: [
   HomepageComponent,
   LoginComponent,
   RegisterComponent,

  ],
  imports: [
    MatCardModule,
    MatProgressSpinnerModule,


    GooglePlaceModule,
    AngularFireModule.initializeApp(environment.firebase),
    ReactiveFormsModule,
    CommonModule,
    CoreRoutingModule
  ]
})
export class CoreModule { }
